import { sendGet, sendPut } from './axios';

// eslint-disable-next-line import/prefer-default-export
export const loadProfile = () => sendGet('/user/me');
export const updateProfile = (id: number, payload: any) => sendPut(`/user/${id}`, payload);
export const changePassword = (payload: any) => sendPut('/auth/change-password', payload);
